export const addressFromRedux =
    () => (_, getState) => {
        const { billing_address, customer } = getState().orders.order;

        const { birthday,
            document_type
        } = customer

        const { firstname,
            lastname,
            country_id,
            street,
            city,
            postal_code,
            phone,
            other,
            company,
            company_code,
            vat_code } = billing_address

        return {
            customer_attributes: {
                birthday,
                personal_code: null,
                document_type,
                document_number: null,
            },
            billing_address_attributes: {
                firstname,
                lastname,
                country_id,
                street,
                city,
                postal_code,
                phone,
                other,
                company,
                company_code,
                vat_code,
            },
        }
    };
